export enum DtwinCertificateImg {
  VALIDITY_GREATER_THAN_SIX_MONTHS = "validityGreaterThanSixMonths",
  VALIDITY_LESS_THAN_SIX_MONTHS = "validityLessThanSixMonths",
  VALIDITY_LESS_THAN_THREE_MONTHS = "validityLessThanThreeMonths",
  VALIDITY_LESS_THAN_ONE_MONTH = "validityLessThanOneMonth",
  EXPIRED = "expired",
}
